<template>
  <div class="data-statistics">
    <!-- 查询条件 -->
    <a-row :gutter="24" class="search-row">
      <a-col :span="12">
        <span class="label">月份：</span>
        <a-range-picker
          v-model="dateRange"
          :placeholder="['开始月份', '结束月份']"
          format="YYYY-MM"
          :mode="['month', 'month']"
          @panelChange="handlePanelChange" />
      </a-col>
      <a-col :span="6">
        <span class="label">{{ type === 1 ? '公司' : '项目' }}：</span>
        <a-select v-model="company" style="width: 160px" placeholder="请选择">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for="item in companyList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4">
        <a-button type="primary" @click="handleSearch">查询</a-button>
        <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
      </a-col>
    </a-row>

    <!-- 统计卡片 -->
    <a-row :gutter="24" class="stat-row">
      <a-col :span="12">
        <div class="stat-card">
          <div class="stat-title">总激活数</div>
          <div class="stat-value">{{ totalActivation }}</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="stat-card">
          <div class="stat-title">近6月激活数</div>
          <div class="stat-value">{{ last6MonthsActivation }}</div>
        </div>
      </a-col>
    </a-row>

    <!-- 图表 -->
    <a-row class="chart-row">
      <a-col :span="24">
        <div class="chart-container">
          <v-chart
            :height="350"
            :data="chartData"
            :scale="scale"
            :forceFit="true"
            :padding="['auto', 'auto', '40', '50']">
            <v-tooltip />
            <v-axis />
            <v-bar position="month*value" color="#5B8FF9" />
          </v-chart>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getStatistics, listCompanyPage } from '@/api/company'
import { getProjectFirstItemPage, getProjectFirstItemStatistics } from '@/api/projectItem'
import moment from 'moment'
export default {
  name: 'DataStatistics',
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dateRange: [],
      company: '',
      companyList: [],
      totalActivation: 10000,
      last6MonthsActivation: 2000,
      chartData: []
    }
  },
  computed: {
    scale () {
      return [
        {
          dataKey: 'value',
          alias: '激活数',
          min: 0,
          nice: true
        },
        {
          dataKey: 'month',
          alias: '月份'
        }
      ]
    }
  },
  mounted () {
    this.loadCompanyList()
    this.fetchStatisticsData()
  },
  methods: {
    initData (response) {
      // 模拟近6个月的图表数据
      const data = []
      const months = response.data && response.data.result && response.data.result.map(month => month._id)
      const values = response.data && response.data.result && response.data.result.map(month => month.count)
      console.log(months, values)
      months && months.forEach((month, index) => {
        data.push({
          month: month,
          value: values[index]
        })
      })
      console.log(data)
      this.chartData = data
    },
    loadCompanyList () {
      // 公司统计
      if (this.type === 1) {
        listCompanyPage().then(response => {
          this.companyList = response.data || []
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.loading = false
        })
        return
      }
      // 项目统计
      if (this.type === 2) {
        getProjectFirstItemPage().then(response => {
          this.companyList = response.data || []
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handlePanelChange (value, mode) {
      this.dateRange = value
    },
    handleSearch () {
      // 根据查询条件获取数据
      console.log('查询条件：', {
        dateRange: this.dateRange,
        company: this.company
      })
      // 这里调用API获取数据
      this.fetchStatisticsData()
    },
    handleReset () {
      this.dateRange = []
      this.company = ''
      this.initData()
    },
    fetchStatisticsData () {
      // 两个都为undefined时，默认查询近六个月数据
      if (!this.dateRange[0] && !this.dateRange[1]) {
        this.dateRange = [moment().subtract(5, 'month').format('YYYY-MM'), moment().format('YYYY-MM')]
      }
      // 公司统计
      if (this.type === 1) {
        getStatistics({
          startMonth: this.dateRange[0] ? moment(this.dateRange[0]).format('YYYY-MM') : '',
          endMonth: this.dateRange[1] ? moment(this.dateRange[1]).format('YYYY-MM') : '',
          companyId: this.company
        }).then(response => {
          console.log(response)
          this.totalActivation = response.data.totalActiveCnt
          this.last6MonthsActivation = response.data.sixMonthCnt
          this.initData(response)
        })
      }
      // 项目统计
      if (this.type === 2) {
        getProjectFirstItemStatistics({
          startMonth: this.dateRange[0] ? moment(this.dateRange[0]).format('YYYY-MM') : '',
          endMonth: this.dateRange[1] ? moment(this.dateRange[1]).format('YYYY-MM') : '',
          projectId: this.company
        }).then(response => {
          console.log(response)
          this.totalActivation = response.data.totalActiveCnt
          this.last6MonthsActivation = response.data.sixMonthCnt
          this.initData(response)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.data-statistics {
  padding: 20px;

  .search-row {
    margin-bottom: 24px;

    .label {
      display: inline-block;
      margin-right: 8px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .stat-row {
    margin-bottom: 24px;

    .stat-card {
      background: #a8a8a8;
      border-radius: 4px;
      padding: 20px;
      text-align: center;
      color: #fff;

      .stat-title {
        font-size: 14px;
        margin-bottom: 8px;
      }

      .stat-value {
        font-size: 28px;
        font-weight: bold;
      }
    }
  }

  .chart-row {
    .chart-container {
      background: #fff;
      padding: 20px;
      border-radius: 4px;
    }
  }
}
</style>
